/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Subject_Packaging_LotInputs */

const vi_print_admin_subject_packaging_lot = /** @type {(inputs: Print_Admin_Subject_Packaging_LotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô bao bì`)
};

/**

* @param {Print_Admin_Subject_Packaging_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_subject_packaging_lot = /** @type {((inputs?: Print_Admin_Subject_Packaging_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Subject_Packaging_LotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_subject_packaging_lot(inputs)
});